import Types from "./types";
import { VehicleService } from "../../../service/vehicle-service";
import { LeadServiceJava } from "../../../service/lead-service-java-api";
import { carConsumerService } from "../../../service/car-consumer-gateway-api";
import rtoCmsApi from "../../../utils/parsers/rto-cms-api";

const fetchRTODetailsInit = () => ({ type: Types.FETCH_RTO_DETAILS });

const fetchRTODetailsSuccess = (data) => ({
    type: Types.FETCH_RTO_DETAILS_SUCCESS,
    data });

const setPopularCityDetails = (popularCityDetails) => ({
    type: Types.SET_POPULAR_CITY_DETAILS,
    popularCityDetails
});

const setBanners  = (bannerList) => ({
    type: Types.SET_BANNER_LIST,
    bannerList
});

const fetchRTODetailsFailure = () => ({ type: Types.FETCH_RTO_DETAILS_FAILURE });

const fetchRTODetails = (params) => (dispatch) => {
    dispatch(fetchRTODetailsInit());
    return new Promise((resolve, reject) => {
        VehicleService.fetchRTODetails(params)
            .then(response => {
                dispatch(fetchRTODetailsSuccess(response.data.detail));
                resolve(response.data.detail);
            })
            .catch(error => {
                dispatch(fetchRTODetailsFailure());
                reject(error);
            });
    });
};

const fetchPopularCities = (params) => dispatch => {
    return new Promise((resolve, reject) => {
        VehicleService.fetchPopularCities(params)
            .then(response => {
                dispatch(setPopularCityDetails(response.data.detail));
                resolve();
            })
            .catch(error => {
                reject(error);
            });
    });
};

const updateSSRStatus = (isSSR) => ({ type: Types.UPDATE_SSR_STATUS, isSSR });

const createRtoLead = (payload) => () => {
    return new Promise((resolve, reject) => {
        LeadServiceJava.createRtoLead(payload)
            .then(response => {
                resolve(response.data.detail);
            })
            .catch(error => {
                reject(error);
            });
    });
};

const updateRtoLead = (token, params) => () => {
    return new Promise((resolve, reject) => {
        LeadServiceJava.updateRtoLead(token, params)
            .then(response => {
                resolve(response.data.detail);
            })
            .catch(error => {
                reject(error);
            });
    });
};

const getRtoLeadDetails = (token) => () => {
    return new Promise((resolve, reject) => {
        LeadServiceJava.getRtoLeadDetails(token)
            .then(response => {
                resolve(response.data.detail);
            })
            .catch(error => {
                reject(error);
            });
    });
};

const setVasDetails = (vasDetails) => ({ type: Types.SET_VAS_DETAILS, vasDetails });

const fetchServiceHistoryAmount = (params) => dispatch => {
    return new Promise((resolve, reject) => {
        carConsumerService.fetchServiceHistoryAmount(params)
            .then(response => {
                dispatch(setVasDetails(response.data));
                resolve();
            })
            .catch(error => {
                reject(error);
            });
    });
};

const setQuestions = (questions) => ({ type: Types.SET_QUESTIONS, questions });

const fetchRtoQuestions = (payload) => dispatch => {
    return new Promise((resolve, reject) => {
        VehicleService.getSellOnlineQuestion(payload)
            .then(response => {
                dispatch(setQuestions(response.data.detail.questions));
                resolve(response.data);
            })
            .catch(error => reject(error));
    });
};

const saveRtoQuestion = (payload) => () => {
    return new Promise((resolve, reject) => {
        LeadServiceJava.saveRtoQuestion(payload)
            .then(response => {
                resolve(response.data.detail);
            })
            .catch(error => reject(error));
    });
};

const getPreDeliveryInspectionPrice = () => dispatch => {
    return new Promise((resolve, reject) => {
        LeadServiceJava.getPreDeliveryInspectionPrice({})
            .then(response => {
                // eslint-disable-next-line no-magic-numbers
                dispatch(setVasDetails({ pdiAmount: response.data.amount || 999 }));
                resolve();
            })
            .catch(error => {
                reject(error);
            });
    });
};

// eslint-disable-next-line no-unused-vars
const fetchGalleryContent = (payload) => dispatch => {
    return new Promise((resolve, reject) => {
        VehicleService.getGalleryContent(payload)
            .then(response => {
                dispatch(setBanners(response.data.detail || []));
                resolve(response.data.detail);
            })
            .catch(error => {
                reject(error);
            });
    });
};

const getSeoContent = (payload) => dispatch => {
    return new Promise((resolve, reject) => {
        VehicleService.getSeoContent(payload)
            .then(response => {
                dispatch(fetchRTODetailsSuccess(rtoCmsApi(response.data)));
                resolve();
            })
            .catch(error => {
                reject(error);
            });
    });
};

export {
    fetchRTODetails,
    updateSSRStatus,
    fetchPopularCities,
    createRtoLead,
    updateRtoLead,
    getRtoLeadDetails,
    fetchServiceHistoryAmount,
    fetchRtoQuestions,
    saveRtoQuestion,
    getPreDeliveryInspectionPrice,
    fetchGalleryContent,
    getSeoContent
};
